import { useMutation, useQueries, useQuery } from 'react-query';
import { RemoteUserTermsAgreesRepo } from '@repository/userTermsAgrees/UserTermsAgreesRepo';
import { TERMS_TYPE, PHS_APPLY_TERMS_TYPE, TERMS } from '@domain/constant/v1/termsType';

export const keys = ['phs', 'test', 'terms'];
export const applyTermsCheckNewKeys = [...keys, 'checkNew'];

const remoteUserTermsAgreesRepo = new RemoteUserTermsAgreesRepo();

const fetchTermsAgreeForSn = async (termsSn: number) => {
  const { data } = await remoteUserTermsAgreesRepo.fetchTermsAgreeForSn(termsSn);
  return data.result;
};

const fetchTermsCheckNew = async (termType: TERMS_TYPE) => {
  const { data } = await remoteUserTermsAgreesRepo.fetchTermsCheckNew(termType);
  return data;
};

const createTermsAgree = async (termsSn: number) => {
  const { data } = await remoteUserTermsAgreesRepo.createTermsAgree(termsSn);
  return data.result;
};

//PHS 응시 약관 동의 여부 조회
export function useApplyTermsCheckNew(isEnabled: boolean) {
  return useQueries([
    {
      queryKey: [...applyTermsCheckNewKeys, PHS_APPLY_TERMS_TYPE.PHS_COPYRIGHT_PROTECTION],
      queryFn: () => fetchTermsCheckNew(PHS_APPLY_TERMS_TYPE.PHS_COPYRIGHT_PROTECTION),
      enabled: isEnabled,
    },
    {
      queryKey: [...applyTermsCheckNewKeys, PHS_APPLY_TERMS_TYPE.PHS_PRIVACY_POLICY],
      queryFn: () => fetchTermsCheckNew(PHS_APPLY_TERMS_TYPE.PHS_PRIVACY_POLICY),
      enabled: isEnabled,
    },
  ]);
}

//PHS 문제 저작권 보호 및 유출금지 동의 여부 조회
export function useApplyPCPTermsCheckNew() {
  return useMutation(() => fetchTermsCheckNew(TERMS.PHS_COPYRIGHT_PROTECTION));
}

//PHS 개인정보 수집 및 이용 동의 여부 조회
export function useApplyPPPTermsCheckNew() {
  return useMutation(() => fetchTermsCheckNew(TERMS.PHS_PRIVACY_POLICY));
}

//PHS 튜토리얼 약관 동의 여부 조회
export function useMutationTutorialTermsCheckNew() {
  return useMutation(() => fetchTermsCheckNew(TERMS.PHS_PRACTICE_PRIVACY_POLICY));
}

//PHS 튜토리얼 약관 동의 조회
export function useTutorialTermsCheckNew(isEnabled: boolean) {
  return useQuery(
    [...applyTermsCheckNewKeys, TERMS.PHS_PRACTICE_PRIVACY_POLICY],
    () => fetchTermsCheckNew(TERMS.PHS_PRACTICE_PRIVACY_POLICY),
    {
      enabled: isEnabled,
    },
  );
}

export function useTermsAgreeForSn() {
  return useMutation((termsSn: number) => fetchTermsAgreeForSn(termsSn));
}

export function useInterviewTermsCheckNew(onSuccess?: () => void) {
  return useMutation(() => fetchTermsCheckNew(TERMS.INTERVIEW_PRIVACY_COLLECTION), { onSuccess });
}

export function useCreateTermsAgree() {
  return useMutation((termsSn: number) => createTermsAgree(termsSn));
}
